export default "__VITE_ASSET__6926a736__"